import { createFileRoute } from "@tanstack/react-router";
import { TutorJoinPage } from "@/components/partners/TutorJoinPage";
import { tutorJoinHead } from "@/components/partners/tutor-join-head";

// «Для репетиторов и кружков» (ru, по адресу с префиксом; /tutors/join отдаёт то же самое, canonical — сюда). Ссылка — только в подвале сайта.
export const Route = createFileRoute("/ru/tutors/join")({
  head: () => tutorJoinHead("ru"),
  component: () => <TutorJoinPage lang="ru" />,
});
